import { COUNT_LIMIT, DEFAULT_LIMIT, DEFAULT_OFFSET } from '@shared/config';

// `?limit` and `?offset` are user-editable URL text feeding non-null GraphQL
// variables. Unclamped, a hand-edited `?limit=50000` is forwarded verbatim
// (on the campaigns list that is 5 correlated subqueries per row and ~1.7 kB
// of body per row, linear in whatever the URL asks), and `parseInt('abc')`
// yields NaN, which serialises to null and fails the `Int!` variable with a
// raw GraphQL error. The ceiling is COUNT_LIMIT (500): above every legitimate
// page size in the app (10-100) and the historical client-side cap.
export const MAX_GRAPHQL_INT = 2147483647;

const clampedIntParam = (
  raw: string | null,
  fallback: number,
  max: number,
): number => {
  const parsed = parseInt(raw ?? '', 10);
  if (Number.isNaN(parsed)) {
    return fallback;
  }
  return Math.min(Math.max(parsed, 0), max);
};

export const getPaginationVariables = (
  searchParams: URLSearchParams,
  defaultLimitOverride?: number,
  approximateRowCount = false,
) => {
  const showRealCount = searchParams.get('show_real_count') === 'true';

  let countLimit = undefined;

  if (approximateRowCount === true) {
    if (showRealCount === true) {
      countLimit = undefined;
    } else {
      countLimit = COUNT_LIMIT;
    }
  }

  const limit = clampedIntParam(
    searchParams.get('limit'),
    defaultLimitOverride ?? DEFAULT_LIMIT,
    COUNT_LIMIT,
  );
  // Hasura's `Int!` is 32-bit: anything above surfaces as a raw GraphQL error.
  const offset = clampedIntParam(
    searchParams.get('offset'),
    DEFAULT_OFFSET,
    MAX_GRAPHQL_INT,
  );
  return { countLimit, limit, offset };
};
